import { Component, signal } from '@angular/core';
import { HeaderContacts } from './contacts/header-contacts';
import { HeaderMain } from './main/header-main';
import { HeaderMenu } from './menu/header-menu';
import { WHATSAPP_URL } from './nav-items';

/** Distância de rolagem (px) a partir da qual a barra principal fica fixa no topo. */
const FIXED_OFFSET = 100;

/**
 * Header global: contatos, barra principal (logo + menu), menu mobile e o botão
 * flutuante do WhatsApp.
 */
@Component({
  selector: 'app-header',
  imports: [HeaderContacts, HeaderMain, HeaderMenu],
  templateUrl: './header.html',
  styleUrl: './header.scss',
  host: { '(window:scroll)': 'onScroll()' },
})
export class Header {
  protected readonly menuOpen = signal(false);
  protected readonly fixed = signal(false);
  protected readonly whatsappUrl = WHATSAPP_URL;

  toggleMenu(): void {
    this.menuOpen.update((open) => !open);
  }

  closeMenu(): void {
    this.menuOpen.set(false);
  }

  protected onScroll(): void {
    this.fixed.set(window.scrollY > FIXED_OFFSET);
  }
}
